import type { Locale } from './typings';

const zhTWLocale: Locale = {
  nick: '暱稱',
  mail: '郵箱',
  link: '網址',
  nickError: '暱稱不能少於3個字元',
  mailError: '請填寫正確的郵件地址',
  placeholder: '歡迎評論',
  sofa: '來發評論吧~',
  submit: '提交',
  reply: '回覆',
  cancelReply: '取消回覆',
  comment: '評論',
  more: '載入更多...',
  preview: '預覽',
  uploadImage: '上傳圖片',
  emoji: '表情',
  seconds: '秒前',
  minutes: '分鐘前',
  hours: '小時前',
  days: '天前',
  now: '剛剛',
  uploading: '正在上傳',
  login: '登錄',
  logout: '退出',
  admin: '博主',
  word: '字',
  wordHint: '評論字數應在 $0 到 $1 字之間！\n當前字數：$2',
};

export default zhTWLocale;
